import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';

import { CheckboxFilterService } from '../../services/checkbox-filter.service';

@Component({
  selector: 'app-checkbox-select',
  imports: [
    MatSelectModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatMenuModule,
    FormsModule,
  ],
  template: `
    <mat-form-field>
      <mat-select
        multiple
        panelClass="big-panel"
        [placeholder]="placeholderText"
        [(ngModel)]="data.selectedValues"
      >
        <div class="hidden">
          <mat-option />
        </div>
        <button
          mat-menu-item
          class="menu-checkbox"
          (click)="data.root.value = !data.root.value"
        >
          <mat-checkbox
            [(ngModel)]="data.root.value"
            (click)="$event.stopPropagation()"
            [indeterminate]="data.root.indeterminate"
            color="primary"
            disableRipple
          >
            {{ data.root.attrs.label }}
          </mat-checkbox>
        </button>
        @for (status of data.children; track $index) {
          <button
            mat-menu-item
            class="menu-checkbox menu-checkbox--sub-menu"
            (click)="status.value = !status.value"
          >
            <mat-checkbox
              [(ngModel)]="status.value"
              (click)="$event.stopPropagation()"
              color="primary"
              disableRipple
            >
              {{ status.attrs.label }}
            </mat-checkbox>
          </button>
        }
      </mat-select>
    </mat-form-field>
  `,
})
export class CheckboxSelectComponent<T> {
  @Input({ required: true }) data: CheckboxFilterService<T>;

  @Input() placeholder?: string;

  @Input() name?: string;

  public get placeholderText(): string {
    let text = this.placeholder || 'Records';
    if (this.data.selectedValues.length) {
      text += ` (${this.data.selectedValues.length} applied)`;
    }

    return text;
  }
}
